/* tslint:disable */
/* eslint-disable */
export enum GraphAnnotationType {
  YAxis = 0,
  XAxis = 1,
  YAxisRange = 2,
  XAxisRange = 3,
  Point = 4,
  Text = 5,
  Image = 6
}
